import { render, staticRenderFns } from "./BonusProduction.vue?vue&type=template&id=0295bca6"
import script from "./BonusProduction.vue?vue&type=script&lang=js"
export * from "./BonusProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports